'use client';
import { Typography } from '@curology/ui-components-web/react/Typography';
import { ConfusedEmoji, HeartSelectedEmoji } from 'radiance-ui/lib/icons';
import React from 'react';

const InternalError: React.FC = () => {
  return (
    <div className="cur-flex-grow cur-w-full cur-flex cur-flex-col cur-items-center cur-justify-center cur-px-8 md:bg-h-[calc(100vh-75px)]">
      <ConfusedEmoji
        width={64}
        height={64}
        className="cur-mt-8 cur-inline-block"
      />
      <div className="cur-whitespace-nowrap cur-mt-4">
        <Typography
          size="h1"
          className="cur-mt-8 whitespace-nowrap cur-inline-block"
        >
          Thanks for your patience{' '}
        </Typography>
        <span className="cur-inline-block cur-ml-2 cur-text-primary">
          <HeartSelectedEmoji
            width={24}
            height={24}
            className="cur-inline-block"
          />
        </span>
      </div>
      <Typography className="cur-mt-2 cur-text-center">
        Our system is temporarily down, but whether you’re here to start
        treatment or get in touch about your care, we’re still here for you.
      </Typography>
      <p className="cur-mt-2">👉 Get on the list by reaching out now:</p>
      <div>
        <div>
          📧 <a href="mailto:hello@curology.com">hello@curology.com</a>
        </div>
        <div>
          📱 Text us at <a href="tel:+14152002060">415-200-2060</a>
        </div>
      </div>
    </div>
  );
};

export default InternalError;
